<template>
  <div class="chat-content __container">
    <aha-chat-message
      v-for="chat in chats"
      @retrySendingMessage="retry"
      :key="chat.id"
      :message="chat.message"
      :user="{
        name: chat.name,
        avatar: chat.avatar,
        type: chat.role,
        color: chat.color,
        teamName: chat.teamName,
        isSelf: chat.isSelf,
      }"
      :type="chat.type"
      :timestamp="chat.timestamp"
      :received="chat.received"
      :filteringProfanity="filteringProfanity"
    />
  </div>
</template>
<script>
import AhaChatMessage from './ChatMessage.vue'

export default {
  components: { AhaChatMessage },
  props: {
    chats: {
      type: Array,
      default: () => [],
    },
    filteringProfanity: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
  },

  methods: {
    retry(message) {
      this.$emit('retrySendingMessage', message)
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-content {
  &.__container {
    padding: 12px 12px 0 12px;
    height: 100%;
  }
}
</style>
